import {
  RESET_CHANNELS,
  RESET_CHANNEL,
  RESET_ERROR,
  GET_CHANNELS,
  SET_CHANNELS,
  API_ERROR,
  CREATE_CHANNEL,
  CREATE_CHANNEL_SUCCESS,
  GET_CHANNEL,
  SET_CHANNEL,
  EDIT_CHANNEL,
  EDIT_CHANNEL_SUCCESS,
  DELETE_CHANNEL,
  DELETE_CHANNEL_SUCCESS,
} from "./actionTypes";

const initialState = {
  errorChannel: false,
  loadingChannel: false,
  dataChannel: null,
  successChannel: false,
};

const Channel = (state = initialState, action) => {
  switch (action.type) {
    case RESET_CHANNELS:
      state = {
        ...state,
        errorChannel: false,
        loadingChannel: false,
        loadingChannelDelete: false,
        successChannel: false,
        dataChannel: null,
        dataChannelDelete: null,
      };
      break;
    case RESET_CHANNEL:
      state = {
        ...state,
        errorChannel: false,
        loadingChannel: false,
        successChannel: false,
        dataChannelGetSet: null,
        dataChannelEditCreate: null,
      };
      break;
    case RESET_ERROR:
      state = {
        ...state,
        errorChannel: false,
        loadingChannel: false,
        loadingChannelEditCreate: false,
        loadingChannelActivate: false,
        successChannel: false,
      };
      break;
    case GET_CHANNELS:
      state = {
        ...state,
        errorChannel: false,
        loadingChannel: true,
        dataChannel: null,
      };
      break;
    case SET_CHANNELS:
      state = {
        ...state,
        errorChannel: false,
        loadingChannel: false,
        dataChannel: action.payload,
      };
      break;
    case CREATE_CHANNEL:
      state = {
        ...state,
        errorChannel: false,
        loadingChannelEditCreate: true,
        dataChannelEditCreate: action.payload,
        successChannel: false,
      };
      break;
    case CREATE_CHANNEL_SUCCESS:
      state = {
        ...state,
        errorChannel: false,
        loadingChannelEditCreate: false,
        dataChannelEditCreate: action.payload,
        successChannel: true,
      };
      break;
    case GET_CHANNEL:
      state = {
        ...state,
        errorChannel: false,
        loadingChannel: true,
        dataChannelGetSet: null,
      };
      break;
    case SET_CHANNEL:
      state = {
        ...state,
        errorChannel: false,
        loadingChannel: false,
        dataChannelGetSet: action.payload,
      };
      break;
    case EDIT_CHANNEL:
      state = {
        ...state,
        errorChannel: false,
        loadingChannelEditCreate: true,
        dataChannelEditCreate: action.payload,
        successChannel: false,
      };
      break;
    case EDIT_CHANNEL_SUCCESS:
      state = {
        ...state,
        errorChannel: false,
        loadingChannelEditCreate: false,
        dataChannelEditCreate: action.payload,
        successChannel: true,
      };
      break;
    case API_ERROR:
      state = {
        ...state,
        errorChannel: action.payload,
        loadingChannel: false,
        loadingChannelDelete: false,
        loadingChannelEditCreate: false,
        successChannel: false,
      };
      break;
    case DELETE_CHANNEL:
      state = {
        ...state,
        errorChannel: false,
        loadingChannelDelete: true,
        dataChannelDelete: action.payload,
        successChannel: false,
      };
      break;
    case DELETE_CHANNEL_SUCCESS:
      state = {
        ...state,
        errorChannel: false,
        loadingChannelDelete: false,
        dataChannelDelete: action.payload,
        successChannel: true,
      };
      break;
    default:
      // state = { ...state, errorChannel: false, loadingChannel: false };
      break;
  }
  return state;
};

export default Channel;
